import { makeRequest } from 'utils/requestLogger';

export default () => makeRequest('get', '/api/users/checkout');



// WEBPACK FOOTER //
// ./src/app/services/account/checkout.js